import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

import LandingPage2 from '../../assets/landing-page-2.png';
import LandingPage3 from '../../assets/landing-page-3.png';
import HomeMobile2 from '../../assets/home-mobile-2.png';
import HomeMobile3 from '../../assets/home-mobile-3.png';
import ArrowLeft from '../../assets/arrow-left.png';
import ArrowRight from '../../assets/arrow-right.png';
import IndexBanner02 from '../../assets/index-banner-02.png';
import IndexBannerMobile02 from '../../assets/index-banner-mobile-02.png';

const slides = [
  {
    desktopImg: IndexBanner02,
    mobileImg: IndexBannerMobile02,
    alt: 'AI Detection Banner',
    button: {
      text: 'Learn More',
      href: '/learn-more',
      type: 'learn',
    },
  },
  {
    desktopImg: LandingPage2,
    mobileImg: HomeMobile2,
    alt: 'Landing Page 2',
    button: {
      text: 'Explore Features',
      href: '/features-bird-feeder',
      type: 'explore1',
    },
  },
  {
    desktopImg: LandingPage3,
    mobileImg: HomeMobile3,
    alt: 'Landing Page 3',
    button: {
      text: 'Explore Features',
      href: '/features-pan-tilt',
      type: 'explore1',
    },
  },
];

const CarouselWrapper = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  min-height: 400px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: relative;
  @media (max-width: 900px) {
    width: 100vw;
    aspect-ratio: unset;
    min-height: unset;
    height: 60vw;
    min-height: 300px;
    max-height: 100vh;
  }
`;

const StyledSplide = styled(Splide)`
  width: 100%;
  height: 100%;
  .splide__track {
    height: 100%;
  }
  .splide__slide {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    height: 100%;
    padding: 0;
    margin: 0;
  }
  .splide__pagination {
    bottom: 18px;
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .splide__pagination__page {
    width: 32px;
    height: 6px;
    border-radius: 6px;
    background: #ffe2cc;
    border: none;
    transition: background 0.3s, width 0.3s;
    padding: 0;
    margin: 0 3px;
  }
  .splide__pagination__page.is-active {
    width: 80px;
    background: #f87b15;
  }
  .splide__arrow {
    background: #fff !important;
    border: none;
    width: 48px;
    height: 48px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 1;
    z-index: 2;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 900px) {
      width: 36px;
      height: 36px;
    }
  }
  .splide__arrow--prev {
    left: 24px;
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background: url(${ArrowLeft}) center center/contain no-repeat;
    }
  }
  .splide__arrow--next {
    right: 24px;
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background: url(${ArrowRight}) center center/contain no-repeat;
    }
  }
  .splide__arrow svg {
    display: none;
  }
`;

const CarouselImage = styled.img<{ isSecond?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: ${(props) => (props.isSecond ? 'contain' : 'cover')};
  object-position: center;
  border-radius: 0;
  margin: 0;
  padding: 0;
  display: block;
  background-color: ${(props) => (props.isSecond ? '#000' : 'transparent')};
  ${(props) =>
    props.isSecond && `
      @media (max-width: 900px) {
        margin-left: 2%;
      }
    `}
`;

const SlideButtonWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  padding-bottom: 4rem;
  @media (max-width: 900px) {
    padding-bottom: 2.5rem;
  }
`;

const FirstSlideText = styled.div`
  position: absolute;
  top: 50%;
  left: 6rem;
  transform: translateY(-50%);
  color: #fff;
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.1;
  text-align: left;
  z-index: 2;
  max-width: 40vw;
  @media (max-width: 900px) {
    position: static;
    transform: none;
    left: 0;
    color: #fff;
    font-size: 2rem;
    max-width: 100vw;
    width: 100%;
    text-align: center;
    margin-bottom: 1.5rem;
  }
`;

const ButtonLearnMore = styled.a`
  position: absolute;
  left: 3rem;
  bottom: 2.5rem;
  background: #fff;
  color: #000;
  font-weight: 700;
  font-size: 1.15rem;
  padding: 0.7rem 2.2rem;
  border-radius: 2rem;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(248,123,21,0.12);
  border: none;
  outline: none;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #fde6d2;
    color: #d65c00;
  }
  @media (max-width: 900px) {
    position: static;
    left: 0;
    right: 0;
    margin: 1.5rem auto 0 auto;
    display: block;
    bottom: unset;
    font-size: 1rem;
    padding: 0.6rem 1.5rem;
  }
`;

const ButtonExplore1 = styled.a`
  position: absolute;
  right: 3rem;
  bottom: 2.5rem;
  background: #F87B15;
  color: #000;
  font-weight: 700;
  font-size: 1.15rem;
  padding: 0.7rem 2.2rem;
  border-radius: 2rem;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(248,123,21,0.12);
  border: none;
  outline: none;
  transition: background 0.2s;
  &:hover {
    background: #d65c00;
    color: #fff;
  }
  @media (max-width: 900px) {
    position: static;
    left: 0;
    right: 0;
    width: auto;
    margin: 1.5rem auto 0 auto;
    display: block;
    bottom: unset;
    font-size: 1rem;
    padding: 0.6rem 1.5rem;
  }
`;

const ButtonExplore2 = styled.a`
  position: absolute;
  right: 3rem;
  bottom: 2.5rem;
  background: #fff;
  color: #F87B15;
  font-weight: 700;
  font-size: 1.15rem;
  padding: 0.7rem 2.2rem;
  border-radius: 2rem;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(248,123,21,0.12);
  border: 2px solid #F87B15;
  outline: none;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #fde6d2;
    color: #d65c00;
  }
  @media (max-width: 900px) {
    right: 1rem;
    bottom: 1.2rem;
    font-size: 1rem;
    padding: 0.6rem 1.5rem;
  }
`;

const ButtonExploreLeft = styled.a`
  position: absolute;
  left: 3rem;
  bottom: 2.5rem;
  background: #F87B15;
  color: #000;
  font-weight: 700;
  font-size: 1.15rem;
  padding: 0.7rem 2.2rem;
  border-radius: 2rem;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(248,123,21,0.12);
  border: none;
  outline: none;
  transition: background 0.2s;
  &:hover {
    background: #d65c00;
    color: #fff;
  }
  @media (max-width: 900px) {
    position: static;
    left: 0;
    right: 0;
    width: auto;
    margin: 0.5rem auto 0 auto;
    display: block;
    bottom: unset;
    font-size: 1rem;
    padding: 0.6rem 1.5rem;
  }
`;

const LandingCarousel = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <CarouselWrapper>
      <StyledSplide
        options={{
          type: 'loop',
          perPage: 1,
          arrows: true,
          pagination: true,
          drag: true,
          gap: '0px',
          autoplay: true,
          interval: 5000,
          pauseOnHover: true,
          pauseOnFocus: true,
          speed: 700,
        }}
      >
        {slides.map((slide, idx) => (
          <SplideSlide key={idx}>
            <CarouselImage
              src={isMobile ? slide.mobileImg : slide.desktopImg}
              alt={slide.alt}
              draggable={false}
              isSecond={idx === 1}
            />
            {(idx === 0 && isMobile) ? (
              <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, left: 0, zIndex: 10 }}>
                <FirstSlideText>
                  Sensforge:<br />Where Security<br />Meets Fun
                </FirstSlideText>
                <ButtonLearnMore href={slide.button.href}>{slide.button.text}</ButtonLearnMore>
              </div>
            ) : (idx > 0 && isMobile) ? (
              <div style={{ position: 'absolute', left: 0, right: 0, bottom: '2.5rem', display: 'flex', justifyContent: 'center', zIndex: 10 }}>
                {slide.button && slide.button.type === 'explore1' && (
                  <ButtonExploreLeft href={slide.button.href}>{slide.button.text}</ButtonExploreLeft>
                )}
              </div>
            ) : (
              <>
                {idx === 0 && (
                  <FirstSlideText>
                    Sensforge:<br />Where Security<br />Meets Fun
                  </FirstSlideText>
                )}
                <SlideButtonWrapper>
                  {slide.button && slide.button.type === 'learn' && (
                    <ButtonLearnMore href={slide.button.href}>{slide.button.text}</ButtonLearnMore>
                  )}
                  {slide.button && slide.button.type === 'explore1' && (
                    idx === 1 ? (
                      <ButtonExploreLeft href={slide.button.href}>{slide.button.text}</ButtonExploreLeft>
                    ) : (
                      <ButtonExplore1 href={slide.button.href}>{slide.button.text}</ButtonExplore1>
                    )
                  )}
                </SlideButtonWrapper>
              </>
            )}
          </SplideSlide>
        ))}
      </StyledSplide>
    </CarouselWrapper>
  );
};

export default LandingCarousel;
